import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "m14.933 13.021.074.188c.653 1.66 2.022 2.967 3.743 3.577l.194.069-.192.069c-1.703.61-3.033 1.917-3.638 3.577l-.068.187-.074-.187c-.653-1.66-2.022-2.968-3.742-3.577l-.195-.07.192-.068c1.703-.61 3.033-1.918 3.638-3.577zM8.648 16.844l.043.107a3.57 3.57 0 0 0 2.138 2.044l.111.04-.11.039a3.43 3.43 0 0 0-2.078 2.044l-.04.107-.041-.107a3.57 3.57 0 0 0-2.139-2.044l-.111-.04.11-.039a3.43 3.43 0 0 0 2.078-2.044zM11.012 14.748l.114-.299a9.76 9.76 0 0 1 5.796-5.683l.302-.11-.3-.109a9.47 9.47 0 0 1-5.674-5.683l-.107-.298-.114.298a9.76 9.76 0 0 1-5.796 5.683l-.302.11.3.11a9.47 9.47 0 0 1 5.674 5.682z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "ai-icon"}) } }